export enum NotificationMessageType {
    Success,
    Warn,
    Error,
}
